import { descriptionPlainForValidation } from '../../utils/productDescriptionHtml';

export const ADD_PRODUCT_WIZARD_STEPS = [
  {
    id: 'categories',
    title: 'Categories',
    subtitle: 'Choose category, subcategory & children',
  },
  {
    id: 'name',
    title: 'Product name',
    subtitle: 'Name, SKU, pricing & URL',
  },
  {
    id: 'media',
    title: 'Photos & video',
    subtitle: 'Product images and optional showcase video',
  },
  {
    id: 'description',
    title: 'Description',
    subtitle: 'Tell shoppers about this product',
  },
  {
    id: 'brand',
    title: 'Brand & material',
    subtitle: 'Brand name and material tags',
  },
  {
    id: 'inventory',
    title: 'Colors, sizes & stock',
    subtitle: 'Variants and inventory quantities',
  },
];

function parsePositivePrice(value) {
  const price = parseFloat(String(value ?? ''));
  if (value === undefined || value === null || value === '' || Number.isNaN(price) || price <= 0) {
    return null;
  }
  return price;
}

/** Human-readable missing fields for the current wizard step. */
export function getAddProductWizardStepMissingFields(stepIndex, ctx) {
  const { newProduct, uploadedImages } = ctx;
  const missing = [];
  const name = String(newProduct?.name ?? '').trim();
  const category = String(newProduct?.category ?? '').trim();
  const brand = String(newProduct?.brand ?? '').trim();
  const descPlain = descriptionPlainForValidation(newProduct?.description);
  const images = Array.isArray(uploadedImages) ? uploadedImages : [];
  const totalStock = typeof ctx.getTotalStock === 'function' ? ctx.getTotalStock() : 0;

  switch (stepIndex) {
    case 0:
      if (!category) missing.push('Category');
      break;
    case 1: {
      if (!name) missing.push('Product name');
      const originalPrice = parsePositivePrice(newProduct?.originalPrice);
      if (originalPrice === null) missing.push('Original price');
      const saleRaw = newProduct?.salePrice;
      if (saleRaw !== undefined && saleRaw !== null && String(saleRaw).trim() !== '') {
        const salePrice = parseFloat(String(saleRaw));
        if (Number.isNaN(salePrice) || salePrice <= 0) {
          missing.push('Valid sale price');
        } else if (originalPrice !== null && salePrice >= originalPrice) {
          missing.push('Sale price lower than original price');
        }
      }
      break;
    }
    case 2:
      if (images.length === 0) missing.push('At least one product photo');
      break;
    case 3:
      if (!descPlain || !String(descPlain).trim()) missing.push('Description');
      break;
    case 4:
      if (!brand) missing.push('Brand');
      break;
    case 5:
      if (totalStock < 1) missing.push('Stock quantity (at least 1)');
      break;
    default:
      break;
  }

  return missing;
}

export function isAddProductWizardStepComplete(stepIndex, ctx) {
  return getAddProductWizardStepMissingFields(stepIndex, ctx).length === 0;
}

export function formatWizardStepMissingMessage(stepIndex, missing) {
  if (!missing || missing.length === 0) return '';
  const step = ADD_PRODUCT_WIZARD_STEPS[stepIndex];
  const stepTitle = step?.title || `Step ${stepIndex + 1}`;
  return `Please complete "${stepTitle}" before continuing. Missing: ${missing.join(', ')}`;
}

/** Next / Publish is always available in the wizard; step validation runs on click. */
export function canShowWizardNextButton() {
  return true;
}
